module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Promo_Mobile', {
		configure: function (options) {
			this.registerOptions('', {
				template: 'promo_mobile_app',
				'hooks.onStartRendering': function () {
					var currentLang = fox.i18n.lang;
					this.setTemplateOptions({ lang: currentLang });
					
				},

				widgets: {
					regForm: {
						widget: 'Promo_Registration',
						active: false,
						autoRender: false,
						container: '.registration-block',
						template: 'promo_reg_form'
					},
				},
				
				handleDom: {
					toRegistration: {
						target: '.continue',
						event: 'click',
						callback: function() {
							this.scrollSection('registration');
						}
					},
				},

				'handleWom.addedToDom': {
					widget: '@this',
					event: 'addedToDom',
					callback: fox.bind(function (argument) {
						this.createGalleries();
						if (fox.isEmpty(fox.site.member)) {
							var regForm = this.wom1('#regForm');
							regForm.activate().render();
						}
					}, this),
					'params.prefix': 'customHandlers'
				}
			});

			this.callParent('configure', arguments);
		},


		createGalleries: function () {
			if (!$('.slick-initialized')[0]) {
				this.createTouchFeaturesGallery();
			} else {
				$('#slider-abilities').slick('setPosition');
			}
		},

		createTouchFeaturesGallery: function () {
			$('#slider-abilities').slick({
				centerMode: false,
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: false,
				arrows: false,
				dots: false,
				adaptiveHeight: true,
				
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							speed: 500,
							fade: true,
							dots: true,
							dotsClass: 'pager',
							infinite: true
						}
					}
				]
			});

		},

		// switchSlide: function(elt) {
		// 	var slideNum = $(elt).attr('data-slide');
		// 	slideNum = (!!slideNum) ? slideNum : 1;
		// 	$(elt).parent().next().slick('slickGoTo', slideNum);
		// }
	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/widget/mobile.js
// module id = 609
// module chunks = 2